module.exports = __webpack_public_path__ + "media/psychotype.2e82feb7.webm";